import { useState } from 'react'

import { splitWords } from '../../lib/wordNotes'
import { wordMark } from '../../lib/words'
import WordSheet from './WordSheet'

/**
 * The practice screen's sentence display (owner request, replacing the old
 * always-on whole-sentence Farsi translation; no go-live-plan item). Every
 * English word is its own tap target; tapping one opens `WordSheet` (V2-w):
 * the shared-dictionary entry with its pronunciation when the word has one,
 * else the admin's note, else a placeholder. `translationFa` is unchanged
 * elsewhere — still authored, still stored — this only changes how this
 * one screen renders it. Since V2-w it is used for video lessons too.
 *
 * Marks: a linked word is underlined solid in the brand colour, a word with
 * only a note dotted, a plain word not at all — so the sentence does not
 * look peppered with affordances for words nobody annotated.
 */
const MARK_CLASS = {
  entry: 'underline decoration-solid decoration-brand-500 decoration-2 underline-offset-4 text-brand-700 dark:text-brand-300',
  note: 'underline decoration-dotted decoration-slate-400 underline-offset-4 dark:decoration-slate-500',
}

export default function TappableSentence({ textEn, wordNotes, words }) {
  const [openIndex, setOpenIndex] = useState(null)
  const tokens = splitWords(textEn)
  const sentence = { wordNotes, words }

  return (
    <>
      <p className="lesson-text ltr mt-4 flex flex-wrap gap-x-1 gap-y-1.5 rounded-xl bg-slate-50 p-4 text-lg leading-relaxed text-slate-800 dark:bg-slate-900 dark:text-slate-100">
        {tokens.map((word, index) => {
          const mark = wordMark(sentence, index)
          return (
            <button
              key={index}
              type="button"
              data-word-index={index}
              data-word-mark={mark ?? undefined}
              onClick={() => setOpenIndex(index)}
              className={`rounded px-1 transition-colors hover:bg-brand-100 hover:text-brand-700 dark:hover:bg-slate-800 ${MARK_CLASS[mark] ?? ''}`}
            >
              {word}
            </button>
          )
        })}
      </p>

      {openIndex !== null && (
        <WordSheet word={tokens[openIndex]} sentence={sentence} index={openIndex} onClose={() => setOpenIndex(null)} />
      )}
    </>
  )
}
